import { on } from 'delegated-events'
import requestTimeout from '../common/requestTimeout'

const header = document.querySelector('.site-header')
const primaryHeader = document.querySelector('.site-primary-header')
const secondaryHeader = document.querySelector('.site-secondary-header')
const searchForm = document.querySelector('.site-header-search form')

const state = {
  stuck: true,
  prevScroll: window.scrollY || document.documentElement.scrollTop,
  currScroll: 0,
  scrollDir: 0,
  prevDir: 0,
}

const fn = {
  init: () => {
    fn.handleScroll()
    fn.bindEvents()

    on('click', '.site-search-trigger', fn.handleOpenSearch)
    on('click', '.site-search-close', fn.handleCloseSearch)

    if (searchForm) {
      searchForm.addEventListener('submit', fn.handleSearchSubmit)
      searchForm.addEventListener('keyup', fn.handleSearchKeyUp)
    }
  },

  bindEvents: () => {
    window.addEventListener('scroll', fn.handleScroll)
  },

  handleScroll: () => {
    state.stuck = primaryHeader.getBoundingClientRect().top <= 0
    state.currScroll = window.scrollY || document.documentElement.scrollTop

    if (state.currScroll > state.prevScroll + 10) {
      state.scrollDir = 'down'
    } else if (state.currScroll < state.prevScroll - 10) {
      state.scrollDir = 'up'
    }

    state.prevScroll = state.currScroll

    if (state.scrollDir === 'up') {
      document.documentElement.classList.add('is-scrolling-up')
    } else {
      document.documentElement.classList.remove('is-scrolling-up')
    }

    header.classList.toggle('is-stuck', state.stuck)
    header.classList.toggle('is-scrolled', state.currScroll > secondaryHeader.offsetHeight)
  },

  handleOpenSearch: () => {
    document.documentElement.classList.add('js-search-active')

    requestTimeout(() => {
      searchForm.querySelector('input').focus()
    }, 250)
  },

  handleCloseSearch: () => {
    document.documentElement.classList.remove('js-search-active')

    searchForm.querySelector('input').value = null
    searchForm.classList.remove('has-error')
  },

  handleSearchSubmit: (e) => {
    const input = e.target.querySelector('input')

    if (input.value === '') {
      e.preventDefault()
      searchForm.classList.add('has-error')
      input.focus()
    }
  },

  handleSearchKeyUp: () => {
    searchForm.classList.remove('has-error')
  },
}

export default {
  can: () => header,
  run: fn.init,
}
